(() => {
  const key = 'springfields:last-collection';
  if (/^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?collections\//.test(location.pathname)) {
    try { sessionStorage.setItem(key, location.pathname + location.search); } catch (_) {}
  }
  const isMobileAccordion = (menu) => menu.hasAttribute('data-inline-accordion') && menu.closest('header-drawer');
  // Mobile catalogue headings own their toggle. Do not send their clicks
  // through the drawer's animated-submenu handler or toggle details twice.
  document.addEventListener('click', (event) => {
    const heading = event.target.closest('[data-catalogue-menu] > summary');
    if (!heading || !isMobileAccordion(heading.parentElement)) return;
    event.preventDefault();
    event.stopPropagation();
    const menu = heading.parentElement;
    menu.open = !menu.open;
    heading.setAttribute('aria-expanded', String(menu.open));
  }, true);
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-continue-shopping]');
    if (link) {
      try {
        const saved = sessionStorage.getItem(key);
        if (saved) {
          const url = new URL(saved, location.origin);
          if (url.origin === location.origin && /^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?collections\//.test(url.pathname)) link.href = url.href;
        }
      } catch (_) {}
    }
    document.querySelectorAll('[data-catalogue-menu][open]').forEach((menu) => {
      if (!isMobileAccordion(menu) && !menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const menu = event.target.closest('[data-catalogue-menu][open]');
    if (menu) {
      event.preventDefault();
      event.stopPropagation();
      menu.open = false;
      const heading = menu.querySelector('summary');
      heading.setAttribute('aria-expanded', 'false');
      heading.focus();
    }
  });
  document.addEventListener('focusin', (event) => {
    document.querySelectorAll('[data-catalogue-menu][open]').forEach((menu) => {
      if (!isMobileAccordion(menu) && !menu.contains(event.target)) menu.open = false;
    });
  });
})();
